import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=3c1f9882&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=3c1f9882&prod&scoped=true&lang=css&"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=3c1f9882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f9882",
  null
  
)

export default component.exports